import { IEntity } from 'viggo-sistemas-core-web';

import { IParceiro } from '@app/modules/parceiro/model';

export enum TIPO_CNH {
  A = 'Categoria A',
  B = 'Categoria B',
  C = 'Categoria C',
  D = 'Categoria D',
  E = 'Categoria E',
  ACC = 'Categoria ACC'
}

export interface IMotorista extends IEntity {
  codigo: number;
  domain_id: string;
  parceiro: IParceiro;
  cnh: string;
  cnh_validade: Date | string;
  cnh_categoria: string | TIPO_CNH;
  data_nascimento: Date | string;
}
